export const bindEvent = (el, type, handle, gesture) => {
  if (el.addEventListener) {
    el.addEventListener(type, handle, gesture)
  } else if (el.attachEvent) {
    el.attachEvent(`on${type}`, handle, gesture)
  }
}

export const removeEvent = (el, type, handle, gesture) => {
  if (el.removeEventListener) {
    el.removeEventListener(type, handle, gesture)
  } else if (el.detachEvent) {
    el.detachEvent(`on${type}`, handle, gesture)
  }
}



// WEBPACK FOOTER //
// ./src/util/index.js